import { useContactUsEmailStorage } from "@/components/support/contactUs/email/contact-us-email-storage";
import { cn } from "@/libs/utils";
import { useTrans } from "@/utils/useTrans";
import { Button } from "@/v2-components/ui/button";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import { SUPPORT_HUB_URL } from "@/constants/Urls.ts";

type Props = React.HTMLAttributes<HTMLElement>;

const Label = ({ className, ...rest }: Props) => (
  <h4 {...rest} className={cn("text-lg font-600", className)} />
);
const Desc = ({ className, ...rest }: Props) => (
  <h5 {...rest} className={cn("", className)} />
);
const Number = ({ className, ...rest }: Props) => (
  <div
    className={cn(
      "flex aspect-square min-w-6 max-w-6 items-center justify-center rounded-full border border-coolgray-60 text-sm font-600 text-blue-60",
      className,
    )}
    {...rest}
  />
);

const TryTheFollowing = () => {
  const { t } = useTrans(["games"]);
  return (
    <div>
      <Label>{t("Try the following")}</Label>
      <ul className="mt-4 space-y-3">
        {[
          t("Check for spelling errors."),
          t("Use different keywords or similar terms."),
          t("Search with the official title or abbreviations."),
        ].map((desc, index) => (
          <div key={index} className="flex items-start gap-x-3">
            <Number>{index + 1}</Number>
            <Desc className="py-0.5">{desc}</Desc>
          </div>
        ))}
      </ul>
    </div>
  );
};

const StillNoLuck = () => {
  const { t } = useTrans(["games"]);
  const contactUsEmailStorage = useContactUsEmailStorage();

  return (
    <div className="max-w-60">
      <Label>{t("Try the following")}</Label>
      <div className="mt-4 space-y-5">
        <Desc>
          {t("Get game recommendations and updates in our Discord community!")}
        </Desc>
        <Button variant={"blue-outline"} size={"sm"} shape={"pill"}>
          <Link
            href={SUPPORT_HUB_URL.home}
            target={"_blank"}
            className="flex flex-nowrap items-center gap-x-2.5 px-4 py-2.5"
            onClick={() => {
              contactUsEmailStorage.set({
                category: "game-software",
                topic: "game-request",
                description: "",
                email: "",
                name: "",
                files: [{ link: "", description: "" }],
                links: [""],
                "game-request": [{ title: "", platform: "" }],
                selectedOrders: [],
                "return-cancellation-agree-policy": false,
              });
            }}
          >
            <span>{t("Request a Game")}</span>
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default function ContentsNotFound() {
  const { t } = useTrans(["games"]);
  return (
    <>
      <div className="w-full text-base font-400">
        <div className="mx-auto max-w-screen-max px-4">
          <div className="mb-6 laptop:mb-24 laptop:mt-16">
            <div className="relative mx-auto h-[160px] w-[160px]">
              <Image alt="buzz" src="/images/buzz@2x.png" fill />
            </div>
            <div className="mx-auto mt-6 max-w-screen-xs text-center">
              <h2 className="text-lg laptop:text-2xl">
                {t(
                  "Can’t find the bHaptics-supported game you’re looking for?",
                )}
              </h2>
            </div>
            <div className="mx-auto mt-9 flex max-w-screen-tablet flex-wrap gap-x-4 gap-y-6 px-7.5 xsm:flex-nowrap laptop:mt-12 laptop:gap-y-10">
              <div className="grow">
                <TryTheFollowing />
              </div>
              <div>
                <StillNoLuck />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
